export default "__VITE_ASSET__345c7e31__"